/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  KillswitchCapability,
  KillswitchCapability$inboundSchema,
} from "./killswitchcapability.js";
import {
  KillswitchComingSoonCapability,
  KillswitchComingSoonCapability$inboundSchema,
} from "./killswitchcomingsooncapability.js";

export type KillswitchListCapabilitiesResult = {
  capabilities: Array<KillswitchCapability>;
  comingSoon: Array<KillswitchComingSoonCapability>;
};

/** @internal */
export const KillswitchListCapabilitiesResult$inboundSchema: z.ZodMiniType<
  KillswitchListCapabilitiesResult,
  unknown
> = z.pipe(
  z.object({
    capabilities: z.array(KillswitchCapability$inboundSchema),
    coming_soon: z.array(KillswitchComingSoonCapability$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "coming_soon": "comingSoon",
    });
  }),
);

export function killswitchListCapabilitiesResultFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchListCapabilitiesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchListCapabilitiesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchListCapabilitiesResult' from JSON`,
  );
}
